import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { MatterService } from '../../../services/matters/matter.service';

@Component({
  selector: 'app-matter-events',
  templateUrl: './matter-events.component.html',
  styleUrls: ['./matter-events.component.css'],
})
export class MatterEventsComponent implements OnInit, OnChanges {
  /**
   * Matter id from parent component
   */
  @Input() matter_id: number;

  /**
   * Count of all events for this matter
   * @type {number}
   */
  count: number = 0;

  /**
   * Events in current page
   * @type {any}
   */
  events: any = [];

  /**
   * Indicates if events is loading
   * @type {boolean}
   */
  loading: boolean = true;

  /**
   * Search options for events
   * @type {any}
   */
  searchOptions: any = { per_page: 20 };

  /**
   * Search params for the events request
   * @type {any}
   */
  searchParams: any = { page: 1 };

  constructor(private matterService: MatterService) {}

  // Component lifecycle events
  ngOnInit() {
    this.matterService
      .eventsSearchOptions(this.matter_id)
      .then((response_json) => {
        this.searchOptions = response_json;
        this.loadEvents();
      })
      .catch(() => {
        this.loadEvents();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue) this.loadEvents();
  }

  // Component methods
  loadEvents() {
    this.matterService.getEvents(this.matter_id, this.searchParams).then((response_json) => {
      this.count = response_json.count;
      this.events = response_json.events;
      this.loading = false;
    });
  }

  pageChanged($event: any) {
    this.searchParams.page = $event.page;
    this.loadEvents();
  }
}
